module.exports = __webpack_public_path__ + "img/revAn.3eec4aa2.gif";